import React from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './HeaderRow.module.scss';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../shared/components/buttons';
import { SortMethods } from '../ScanIqSubscriptionsManagement.settings';

type HeaderRowProps<TBillingPeriodTypeKey extends string, TNameKey extends string> = {
  sortMethods: SortMethods<TBillingPeriodTypeKey, TNameKey>;
};

const HeaderRow = <TBillingPeriodTypeKey extends string, TNameKey extends string>({
  sortMethods,
}: HeaderRowProps<TBillingPeriodTypeKey, TNameKey>) => {
  const { getIsActive, onSort, nameKey, billingPeriodTypeKey } = sortMethods;

  return (
    <GridTableRow variant="unstyled" className={classes.header}>
      <GridTableCell justify="center">Active</GridTableCell>
      <SortButtons fieldName={nameKey} onSort={onSort} getIsActive={getIsActive}>
        <GridTableCell>Name</GridTableCell>
      </SortButtons>
      <SortButtons
        fieldName={billingPeriodTypeKey}
        onSort={onSort}
        getIsActive={getIsActive}
      >
        <GridTableCell>Type</GridTableCell>
      </SortButtons>
      <GridTableCell>Subtotal</GridTableCell>
      <GridTableCell>
        <TitleWithDescription
          title="Total"
          description="sales tax"
          titleFont="body-14-bold"
          withoutGap
        />
      </GridTableCell>
      <GridTableCell>Total Fees</GridTableCell>
      <GridTableCell justify="center">Display to user</GridTableCell>
    </GridTableRow>
  );
};

export { HeaderRow };
